export * from './shared.validators';



// WEBPACK FOOTER //
// ./src/app/shared/validators/index.ts